import { Link } from "react-router-dom";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import WinGridDark from "../Hero/WinGridDark";
import orlandoMagic from '../../assets/images/companyLogos/white/orlando-magic-logo.webp';
import guidewell from '../../assets/images/companyLogos/white/Guidewell.webp';
import stax from '../../assets/images/companyLogos/white/Stax.webp';
import homeLendingPal from '../../assets/images/companyLogos/white/Home-lending-pal.webp';
import mapleStreet from '../../assets/images/companyLogos/white/Maple-STreet.webp';
import ability from '../../assets/images/companyLogos/white/Ability.webp';
import airehealth from '../../assets/images/companyLogos/white/Airehealth.webp';
import msssey from '../../assets/images/companyLogos/white/Msssey.webp';
import collective from '../../assets/images/companyLogos/white/Collective.webp';
import employmentTech from '../../assets/images/companyLogos/white/EmploymentTechnologies.webp';
import ipd from '../../assets/images/companyLogos/white/Ipd.webp';
import polis from '../../assets/images/companyLogos/white/Polis.webp';
import statusphere from '../../assets/images/companyLogos/white/Statusphere-svg.webp';
import cornerstone from '../../assets/images/companyLogos/white/cornerstone-logo.webp';
import rocketeer from '../../assets/images/companyLogos/white/rocketeer-logo.png';
import goodpour from '../../assets/images/companyLogos/white/the-good-pour-logo.png';
import nexus from '../../assets/images/companyLogos/white/nexus-Logo.png';

const logoData = [
  {
    logoUrl: orlandoMagic,
    href: "/",
  },
  {
    logoUrl: guidewell,
    href: "/",
  },
  {
    logoUrl: stax,
    href: "/",
  },
  {
    logoUrl: homeLendingPal,
    href: "/",
  },
  {
    logoUrl: cornerstone,
    href: "/",
  },
  {
    logoUrl: rocketeer,
    href: "/",
  },
  {
    logoUrl: goodpour,
    href: "/",
  },
  {
    logoUrl: nexus,
    href: "/",
  },
  {
    logoUrl: ability,
    href: "/",
  },
  {
    logoUrl: airehealth,
    href: "/",
  },
  {
    logoUrl: msssey,
    href: "/",
  },
  {
    logoUrl: collective,
    href: "/",
  },
  {
    logoUrl: employmentTech,
    href: "/",
  },
  {
    logoUrl: ipd,
    href: "/",
  },
  {
    logoUrl: polis,
    href: "/",
  },
  {
    logoUrl: statusphere,
    href: "/",
  },
];

export default function ClientLogosSlider() {
  const swiperOptions = {
    modules: [Autoplay],
    slidesPerView: 3,
    spaceBetween: 30,
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    pagination: false,
    navigation: false,
    breakpoints: {
      640: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 5,
        spaceBetween: 40,
      },
      1024: {
        slidesPerView: 6,
        spaceBetween: 50,
      },
    },
  };
  return (
    <section id="home-one-client bg-main-black">
      <div
        className="relative flex justify-center w-full py-0 pt-12 overflow-hidden bg-main-black pointer-events-none mt-[100px] mb-[120px]"
      >
        <div className="absolute inset-0 pointer-events-auto">
          <WinGridDark />
        </div>
        
        <div className="relative z-10 2xl:px-[152px] md:px-10 xl:xl:py-[75px] md:py-[30px] px-5 py-10 overflow-x-hidden">
          <h3 className="text-base text-white text-center font-semibold mb-4">
            Trusted by Innovators
          </h3>
          <p className="text-base text-white font-medium mb-[50px] text-center">
            We've partnered with companies across domains to deliver digital innovation.
          </p>
          <Swiper {...swiperOptions} className="w-full h1-partner_slider pointer-events-auto">
            {logoData.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="flex justify-center items-center client-item h-[120px]">
                  <Link to={item.href} aria-label="partner">
                    <img
                      src={item.logoUrl}
                      alt="logo"
                      className={`w-auto object-contain filter grayscale opacity-70 hover:opacity-100 transition-opacity duration-300 ${
                        item.logoUrl === goodpour ? 'h-[80px]' : 'max-h-[50px]'
                      }`}
                    />
                  </Link>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}
